<div class="flex justify-center w-full md:mt-11 pb-8">
  <img class="w-3/5 md:w-1/4 cursor-pointer" src="assets/icons/Icons/other-payment-options/Apple_Pay_Mark.svg" alt="Apple Pay logo" (click)="selectMethod($event)">
</div>
<div class="w-full">
  <p class="my-6">Pay seamlessly and securely using Apple Pay&#33;</p>

  <!-- Instructions for Windows Users -->
  <h3 class="font-bold mb-2">For Windows users:</h3>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 1:</b>
    <p class="col-span-3 md:col-span-5">Click on the Apple Pay button on the website using your Windows PC.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 2:</b>
    <p class="col-span-3 md:col-span-5">A QR code will appear, prompting you to complete the payment using your iPhone.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 3:</b>
    <p class="col-span-3 md:col-span-5">Open the Wallet app on your iPhone and scan the QR code displayed on your Windows screen.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 4:</b>
    <p class="col-span-3 md:col-span-5">Review your payment details on your iPhone.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 5:</b>
    <p class="col-span-3 md:col-span-5">Authenticate using Face ID, Touch ID, or your passcode.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 6:</b>
    <p class="col-span-3 md:col-span-5">Once confirmed, your payment will be processed and you’ll receive a confirmation on your iPhone.</p>
  </div>

  <!-- Instructions for MacOS/iPhone Users -->
  <h3 class="font-bold mt-6 mb-2">For MacOS/iPhone users:</h3>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 1:</b>
    <p class="col-span-3 md:col-span-5">Click on the Apple Pay button in your app or on your Mac.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 2:</b>
    <p class="col-span-3 md:col-span-5">Review your payment and shipping details in the pop-up window.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 3:</b>
    <p class="col-span-3 md:col-span-5">If using a Mac with Touch ID, authenticate by placing your finger on Touch ID. On an iPhone, use Face ID or Touch ID.</p>
  </div>
  <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
    <b class="col-span-1">Step 4:</b>
    <p class="col-span-3 md:col-span-5">Wait for the payment to be processed and view the confirmation screen.</p>
  </div>
</div>
